var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.item && _vm.item.severity)?_c('div',{staticClass:"issue-severity-chip-cell"},[_c('issue-severity-chip',{attrs:{"issue":_vm.item}})],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }